import { useCallback, useEffect, useState } from 'react';

import { validAccountNumber } from '@eika-infrastruktur/format';

import { useOcrMutation } from '../../../../fetchHooks/useOcr';
import toSelectedReceiver, { PartialReceiver, SelectedReceiver } from '../../SelectedReceiver';

const usePartialReceiverOcr = (
    curryChange: (selectedReceiver: SelectedReceiver | undefined) => void,
    resetSearchString: () => void,
) => {
    const [selectedPartialReceiver, setSelectedPartialReceiver] = useState<PartialReceiver>();
    const [invalidAccountNumber, setInvalidAccountNumber] = useState<string | undefined>();
    const ocr = useOcrMutation(
        (data, variables) => curryChange(toSelectedReceiver(variables, data)),
        () => curryChange(undefined),
    );

    const selectReceiver = useCallback(
        (item?: SelectedReceiver) => {
            setInvalidAccountNumber(undefined);
            curryChange(
                item?.accountNumber ? toSelectedReceiver({ accountNumber: item.accountNumber }, undefined) : undefined,
            );
            if (item && validAccountNumber(item.accountNumber.value)) {
                setSelectedPartialReceiver(item);
                ocr.mutate(item);
            } else {
                setInvalidAccountNumber(item?.accountNumber.value);
            }
        },
        [curryChange, ocr],
    );

    useEffect(() => {
        if (ocr.data && selectedPartialReceiver) {
            const selectedReceiver = toSelectedReceiver(selectedPartialReceiver, ocr.data);
            curryChange(selectedReceiver);
            if (selectedReceiver.accountName) {
                resetSearchString();
            }
        }
    }, [curryChange, ocr.data, selectedPartialReceiver, resetSearchString]);

    return {
        ocr,
        selectReceiver,
        invalidAccountNumber,
    };
};

export default usePartialReceiverOcr;
